import { useState } from "react";
import { timelineEvents } from "@/mocks/drama";

export default function StoryTimeline() {
  const [active, setActive] = useState(timelineEvents[0].id);

  return (
    <div className="grid grid-cols-1 lg:grid-cols-[280px_1fr] gap-4 md:gap-6">
      <div className="flex lg:flex-col gap-2 overflow-x-auto pb-2 lg:pb-0">
        {timelineEvents.map((event) => {
          const isActive = event.id === active;
          return (
            <button
              key={event.id}
              type="button"
              onClick={() => setActive(event.id)}
              className={`shrink-0 lg:w-full text-left px-3.5 py-3 rounded-lg border transition-colors cursor-pointer ${
                isActive
                  ? "bg-primary-500 border-primary-500 text-background-50"
                  : "bg-background-50 border-background-200 text-foreground-700 hover:border-primary-300"
              }`}
            >
              <span className={`text-xs ${isActive ? "text-primary-100" : "text-accent-600"} font-medium`}>
                {event.stage}
              </span>
              <span className="block text-sm font-bold mt-1 whitespace-nowrap lg:whitespace-normal">{event.title}</span>
            </button>
          );
        })}
      </div>

      <div className="rounded-lg bg-background-50 border border-background-200 p-5 md:p-6">
        {timelineEvents
          .filter((event) => event.id === active)
          .map((event) => (
            <div key={event.id} className="animate-fade-in">
              <span className="inline-flex items-center gap-2 px-2.5 py-1 rounded-md bg-secondary-100 text-secondary-900 text-xs">
                <i className="ri-time-line"></i> {event.episodes}
              </span>
              <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950 mt-3">{event.title}</h3>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mt-3">{event.summary}</p>
            </div>
          ))}
      </div>
    </div>
  );
}